import { AuthStorage } from "utils/auth-storage";
// src/components/CustomTaskDrawer.jsx
import React, { useState } from "react";
import { Drawer, Button, Divider, message, Tooltip, Tag } from "antd";
import { SideBarEndService } from "apis/Services/SideBarService";
import { useParams } from "react-router-dom";
import { DeleteFilled } from "@ant-design/icons";

const EditTaskDrawer = ({
  open,
  onClose,
  taskId,
  taskName,
  dependenciesData,
  getProcurementLogRowDependencies,
}) => {
  const { company_id, id } = useParams();

  // Safety: ensure only data for this specific task is used
  const predecessors = dependenciesData[taskId]?.predecessors || [];
  const successors = dependenciesData[taskId]?.successors || [];

  console.log(dependenciesData[taskId], "DEPENDENCIES");

  const handleDelete = async (itemId, type) => {
    console.log(`Delete ${type} with ID:`, itemId);

    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");

    const deletedData = {
      code,
      loginEmail: email,
      company_id,
      id,
      entryID: taskId,
      successorEntryIDs: type === "successor" ? [itemId] : [],
      predecessorEntryIDs: type === "predecessor" ? [itemId] : [],
    };

    try {
      await SideBarEndService.deleteProcurementLogRowDependencies(deletedData);
      message.success("Dependency deleted successfully!");
    } catch (err) {
      console.log("Error deleting dependency:", err);
      message.error("Something went wrong, please try again.");
    } finally {
      getProcurementLogRowDependencies();
    }
  };

  return (
    <Drawer
      title={taskName || `Task ${taskId}`}
      placement="right"
      width={400}
      open={open}
      onClose={onClose}
    >
      <div className="p-2">
        <div className="p-3 border rounded mb-4">
          {/* <h5 className="fw-bold mb-2">Submittal Information</h5> */}

          {/* <div className="mb-2">
            <span className="fw-semibold">Submittal: </span>
            {dependenciesData[taskId]?.info.specTitle || "-"}
          </div> */}

          <div className="mb-2">
            <span className="fw-semibold">Submittal Number: </span>
            {dependenciesData[taskId]?.info.specNumber || "-"}
          </div>

          <div className="mb-2">
            <span className="fw-semibold">Submittal Revision: </span>
            {dependenciesData[taskId]?.info.specRevision || "-"}
          </div>

          <div className="mb-2">
            <span className="fw-semibold">Contract Issued Release: </span>
            {dependenciesData[taskId]?.info.startDate || "-"}
          </div>

          <div className="mb-2">
            <span className="fw-semibold">Actual Delivery Date: </span>
            {dependenciesData[taskId]?.info.endDate || "-"}
          </div>

          <div className="mb-2">
            {/* <span className="fw-semibold">Completed: </span> */}
            {dependenciesData[taskId]?.info.completed ? (
              <Tag color="green">Workflow Completed</Tag>
            ) : (
              <Tag color="default">Workflow Incomplete</Tag>
            )}
          </div>
        </div>

        <h6 className=" fw-bold">Successors</h6>
        {successors.length === 0 ? (
          <p className="text-gray-500">No successors</p>
        ) : (
          successors.map((s) => (
            <div
              key={s.id}
              className="d-flex justify-content-between align-items-center rounded mb-2"
            >
              <span>{s.specTitle ? `${s.specTitle}` : `Task ${s.id}`}</span>
              <Tooltip title="Delete Link">
                <Button
                  type="link"
                  onClick={() => handleDelete(s.id, "successor")}
                >
                  <DeleteFilled className=" fs-6 text-danger" />
                </Button>
              </Tooltip>
            </div>
          ))
        )}

        <hr />

        <h6 className=" fw-bold">Predecessors</h6>

        {predecessors.length === 0 ? (
          <p className="text-gray-500 mb-3">No predecessors</p>
        ) : (
          predecessors.map((p) => (
            <div
              key={p.id}
              className=" d-flex justify-content-between align-items-center rounded mb-2"
            >
              <span>{p.specTitle ? `${p.specTitle}` : `Task ${p.id}`}</span>

              <Tooltip title="Delete Link">
                <Button
                  type="link"
                  onClick={() => handleDelete(p.id, "predecessor")}
                >
                  <DeleteFilled className=" fs-6 text-danger" />
                </Button>
              </Tooltip>
            </div>
          ))
        )}
      </div>
    </Drawer>
  );
};

export default EditTaskDrawer;
